import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import Button from '@atlaskit/button';
import messages from './messages';
var ShowMoreButton = function ShowMoreButton(_ref) {
  var onShowMore = _ref.onShowMore;
  return /*#__PURE__*/React.createElement(Button, {
    onClick: onShowMore,
    appearance: "link",
    testId: "paginated-picker.ui.async-select.menu-list.show-more-button"
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.showMoreButtonText));
};
export default ShowMoreButton;